import { useContext } from "react";
import { CommonPropsContext } from "../contexts/CommonPropsContext";
import Fulfilled from "./Fulfilled";

const FulfilledOrderIndex = () => {
  const { dbConnections, loadingContext } =
    useContext(CommonPropsContext);

  return (
    <>
      {!loadingContext ? (
        <>
          {dbConnections.length > 0 &&
            // dbConnections.map((connection_key, index) => (
              <div>
                <Fulfilled connection_key={dbConnections[0]} />
              </div>
            // ))
            }
        </>
      ) : (
        <div id="loader"></div>
      )}
    </>
  );
};

export default FulfilledOrderIndex;
